import Button from '@components/Button';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import BlankEasyCard from './components/BlankEasyCard';
import EasyCardContents from './components/EasyCardContents';
import EasyCardSkeletons from './components/EasyCardSkeletons';
import UpdatePinButton from './components/UpdatePinButton';
import useEasyCards from './hooks/useEasyCards';
import useRegisterKiccEasyCard from './hooks/useRegisterKiccEasyCard';

declare module '@stackflow/config' {
    interface Register {
        EasyCardActivity: {
            isInitialPinSetting?: boolean;
        };
    }
}

const EasyCardActivity: ActivityComponentType<'EasyCardActivity'> = ({ params }) => {
    const { isInitialPinSetting } = params;
    const { t } = useTranslation('easyCard');
    const {
        data, isLoading, isEmpty, pinRegistered,
    } = useEasyCards(isInitialPinSetting);
    const { handleRegisterCard } = useRegisterKiccEasyCard();
    const addDisabled = isEmpty || (data?.cards?.length || 0) >= 10;
    return (
        <AppScreen>
            <CtaLayout
                header={<Header title={t('title')}
                    trailing={<UpdatePinButton pinRegistered={pinRegistered}/> }/>}
                footer={addDisabled ? undefined
                    : <Button onClick={handleRegisterCard}
                        fullWidth >
                        {t('list.registerOther')}
                    </Button>} >
                {isLoading && (
                    <EasyCardSkeletons/>
                )}
                {isEmpty && (
                    <BlankEasyCard/>
                )}
                {!isLoading && (
                    <EasyCardContents cards={data?.cards}/>
                )}
            </CtaLayout>
        </AppScreen>
    );
};

export default EasyCardActivity;
